import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tilt from "react-parallax-tilt";
import myPhoto from "../../assets/MyPhotoV2.jpeg";

function About() {
  return (
    <section className="section">
      <Container>
        <h2 className="section-title fade-in">
          About <span className="purple">Me</span>
        </h2>

        <Row className="align-items-center">
          <Col lg={5} className="fade-in fade-in-delay-1 text-center mb-4 mb-lg-0">
            <Tilt
              tiltMaxAngleX={6}
              tiltMaxAngleY={6}
              glareEnable={true}
              glareMaxOpacity={0.15}
              glareColor="#c770f0"
              glareBorderRadius="16px"
            >
              <img
                src={myPhoto}
                alt="Debojyoti Roy"
                className="about-photo"
              />
            </Tilt>
          </Col>
          <Col lg={7} className="fade-in fade-in-delay-2">
            <div className="about-card">
              <p className="about-text">
                I am a <strong>Founding Mechanical Engineer</strong> at{" "}
                <strong>Armatrix</strong>, where I design{" "}
                <strong>hyper-redundant robotic arms</strong> designed to access
                constrained spaces beyond human reach.
              </p>
              <p className="about-text">
                Previously at <strong>Rekise Marine</strong>, I worked on building{" "}
                <strong>India's first XLAUV</strong>. I also interned at{" "}
                <strong>Bajaj Auto</strong>, developing a{" "}
                <strong>low-cost EVAP safety system</strong> for two-wheeler{" "}
                <strong>fuel tanks</strong> with a significant cost reduction.
              </p>
              <p className="about-text">
                I co-founded <strong>India's first student railway research group</strong>{" "}
                at the institute, and represented India at the{" "}
                <strong>IMechE Railway Challenge 2024</strong> in the{" "}
                <strong>United Kingdom</strong>. I also represented IIT Kharagpur at{" "}
                <strong>Formula Bharat 2023</strong> with the formula student team
                of the institute.
              </p>
              <p className="about-text">
                My experience across <strong>robotics</strong>,{" "}
                <strong>marine engineering</strong>, and{" "}
                <strong>automotive</strong> gives me a cross-domain perspective
                spanning <strong>mechanical design and assembly</strong>,{" "}
                <strong>component selection</strong>,{" "}
                <strong>CAE simulation</strong>, <strong>thermal analysis</strong>,
                and <strong>prototype fabrication</strong>.
              </p>
              <p className="about-text">
                I graduated from <strong>IIT Kharagpur</strong> with the{" "}
                <strong>highest CGPA</strong> in the department being awarded the{" "}
                <strong>Institute Silver Medal</strong>.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;
